import { render, staticRenderFns } from "./brand-listing.vue?vue&type=template&id=17376328&"
import script from "./brand-listing.vue?vue&type=script&lang=js&"
export * from "./brand-listing.vue?vue&type=script&lang=js&"
import style0 from "./brand-listing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports